import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/resume/page.tsx");
